import { render, staticRenderFns } from "./excursion-ticket.vue?vue&type=template&id=2ba74067&"
import script from "./excursion-ticket.vue?vue&type=script&lang=ts&"
export * from "./excursion-ticket.vue?vue&type=script&lang=ts&"
import style0 from "./excursion-ticket.vue?vue&type=style&index=0&id=2ba74067&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports